<template>
    <div class="lp-cta-action">
        <el-radio-group v-model="value.kind" size="small" :disabled="disabled" class="mb-2">
            <el-radio label="scroll">{{ $t("marketing.lp.f.cta_scroll") }}</el-radio>
            <el-radio label="link">{{ $t("marketing.lp.f.cta_link") }}</el-radio>
        </el-radio-group>
        <div v-if="value.kind === 'link'" :class="{ 'mk-invalid': !!errors['cta_action.link'] }">
            <el-input v-model="value.link" :disabled="disabled" placeholder="/p/12-… หรือ https://www.madamefin.com/…" data-field="cta_action.link"></el-input>
            <small v-if="errors['cta_action.link']" class="text-danger">{{ ruleText(errors["cta_action.link"]) }}</small>
        </div>
        <div v-else :class="{ 'mk-invalid': !!errors['cta_action.target_section_id'] }">
            <el-select v-model="value.target_section_id" class="d-block" clearable :disabled="disabled" :placeholder="$t('marketing.lp.f.cta_target')" data-field="cta_action.target_section_id">
                <el-option v-for="s in targets" :key="s.id" :value="s.id" :label="s.label"></el-option>
            </el-select>
            <small v-if="errors['cta_action.target_section_id']" class="text-danger">{{ ruleText(errors["cta_action.target_section_id"]) }}</small>
        </div>
    </div>
</template>

<script>
import { RadioGroup, Radio, Select, Option } from "element-ui";
// CTAAction (§2.2): "เลื่อนไปที่ส่วน" (select of section ids by label) / "ลิงก์".
// `value` is the section's own cta_action object, edited in place.
export default {
    name: "LpCtaAction",
    components: {
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [Select.name]: Select,
        [Option.name]: Option
    },
    props: {
        value: { type: Object, required: true },
        sections: { type: Array, default: () => [] },
        ownId: { type: String, default: "" },
        errors: { type: Object, default: () => ({}) },
        disabled: { type: Boolean, default: false },
        labelOf: { type: Function, required: true }
    },
    computed: {
        targets() {
            return this.sections
                .filter((s) => s.id !== this.ownId && s.type !== "sticky_cta")
                .map((s) => ({ id: s.id, label: this.labelOf(s) }));
        }
    },
    methods: {
        ruleText(rule) {
            const k = "marketing.lp.rule." + rule;
            return this.$te(k) ? this.$t(k) : rule;
        }
    }
};
</script>
